<template>
    <div class="diagram-choose-diagram">
        <div class="diagram-choose-d-item">
            <div class="diagram-choose-d-title">本卦</div>
            <div class="diagram-choose-d-box" @click="clickDiagram('first')">
                <span class="diagram-choose-d-text1">{{!firstDiagramData ? '请选择' : firstDiagramData.text}}</span>
                <span class="diagram-hand-choose-icon"><i class="iconfont icon-down"></i></span>
            </div>
        </div>
        <div class="diagram-choose-d-mid"></div>
        <div class="diagram-choose-d-item">
            <div class="diagram-choose-d-title">变卦</div>
            <div class="diagram-choose-d-box" @click="clickDiagram('second')">
                <span class="diagram-choose-d-text1">{{!secondDiagramData ? '请选择' : secondDiagramData.text}}</span>
                <span class="diagram-hand-choose-icon"><i class="iconfont icon-down"></i></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DiagramChooseDiagram',
    props: {
        parentNode: {
            type: Object,
            default() { }
        } 
    },
    computed: {
        diagramData() {
            return this.$store.state.diagram.diagramData;
        },
        firstDiagramData() {
            return this.$store.state.diagram.firstDiagramData;
        },
        secondDiagramData() {
            return this.$store.state.diagram.secondDiagramData;
        }
    },
    methods: {
        clickDiagram(type) {
            this.$store.state.diagram.chooseDiagramType = type;

            let curPath = this.$router.history.current.path;
            if(curPath.indexOf('embedded') != -1) {
                curPath = this.$router.history.current.fullPath;
                if(this.parentNode && this.parentNode.name == 'Diagram') {
                    curPath = curPath.replace('/diagram', '/diagram/choosediagram/'+type);
                }else if(this.parentNode && this.parentNode.name == 'DiagramEdit') {
                    curPath = curPath.replace('/diagramedit', '/diagramedit/'+this.diagramData.id+'/choosediagram/'+type);
                }
                this.$router.replace(curPath);
            }else {
                if(this.parentNode && this.parentNode.name == 'Diagram') {
                    this.$router.replace('/diagram/choosediagram/'+type);
                }else if(this.parentNode && this.parentNode.name == 'DiagramEdit') {
                    this.$router.replace('/diagramedit/'+this.diagramData.id+'/choosediagram/'+type);
                }
            }
        }
    }
}
</script>